import { Fragment } from 'react';
import { Dashboard } from '../../../components/ExportImgFigma';
import '../styles.scss';
import { AgGridReact } from "ag-grid-react";
import { EyeOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { useNavigate } from 'react-router-dom';
import 'dayjs/locale/vi';
import { getWidthFromHeader, renderValueAsJSX } from '../../../until';
import { formatCurrency } from '../../../services/mixin';

const Overview = ({ stData = {} as any }) => {
  const navigate = useNavigate()
  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    cellRenderer: (params: any) => {
      return (
        <div className='d-flex gap-4 justify-start align-center  h-full'>
          <EyeOutlined
            onClick={() => {
              navigate(`/customer/pooling-data/customer-list/${params.data.contact_id}`);
            }}
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer}`}
          />
        </div>
      )
    },
  }

  return (
    <Fragment>
      <div className='custom-page-css w-full py-3 flex flex-column gap-3'>
        <div className="custom-page-css w-full flex gap-3">
          <div className="custom-page-css  flex flex-1 flex-column rounded border">
            <div className="custom-page-css w-full flex items-center justify-center gap-4 p-3 border-b">
              <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
              </div>
              <span className='custom-page-css text-xl font-light text-475467'>Tổng xe sở hữu
                <span className='custom-page-css font-medium px-1 text-344054'>{stData.cus_total_vehicles}</span>
              </span>

            </div>
            <div className="custom-page-css flex py-2">
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
                <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>{stData.cus_total_vehicles}</span>
                <span className='custom-page-css text-xl font-light text-475467'>Xe du lịch</span>
              </div>
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
                <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>0</span>
                <span className='custom-page-css text-xl font-light text-475467'>Xe tải bus</span>
              </div>
            </div>
          </div>
          <div className="custom-page-css  flex flex-2 flex-column rounded border">
            <div className="custom-page-css w-full flex items-center justify-around gap-4 p-3 border-b">
              <div className="custom-page-css flex items-center justify-center gap-3">
                <div className="custom-page-css flex items-center justify-center p-1 bg-E6F7FF rounded-full ">
                  <img src={Dashboard} alt="" style={{ height: 16, width: 16, objectFit: 'contain' }} />
                </div>
                <span className='custom-page-css text-xl font-light text-475467'>Tổng chi tiêu</span>
              </div>
              <span className='custom-page-css text-xl font-light text-475467'>Tổng xe quan tâm
                <span className='custom-page-css font-medium px-1 text-344054'>{stData.xequantam0?.length}</span>
              </span>

            </div>
            <div className="custom-page-css flex py-2">
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 border-r">
                <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>{formatCurrency(stData.total_order_amount)}</span>
                <span className='custom-page-css text-xl font-light text-475467'>Hóa đơn mua xe </span>
              </div>
              <div className="custom-page-css py-2 flex flex-1 flex-column items-center justify-center gap-1 ">
                <span className='custom-page-css text-2xl font-light font-medium px-1 text-344054'>{formatCurrency(stData.total_service_amount)}</span>
                <span className='custom-page-css text-xl font-light text-475467'>Hóa đơn dịch vụ </span>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
          <span className='custom-page-css font-regular  text-xl text-1890FF border-b-1890FF'>
            Người liên hệ ({stData.contact_person?.length || 0})
          </span>
        </div>
        <div className={` `}>
          <div className="ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
            <AgGridReact<any>
              rowData={stData.contact_person ?? []}
              columnDefs={[
                {
                  headerName: 'Người Liên Hệ',
                  field: 'contact_contact_name',
                  colId: 'contact_contact_name',
                  width: getWidthFromHeader('Người Liên Hệ'),
                  cellRenderer: (params: any) => renderValueAsJSX(params.value,"")
                },
                {
                  headerName: 'CCCD/CMND',
                  field: 'contact_dms_id_card_no',
                  colId: 'contact_dms_id_card_no',
                  width: getWidthFromHeader('CCCD/CMND'),
                  cellRenderer: (params: any) => renderValueAsJSX(params.value,"")
                },
                {
                  headerName: 'Số điện thoại',
                  field: 'contact_tel',
                  colId: 'contact_tel',
                  width: getWidthFromHeader('Số điện thoại'),
                  cellRenderer: (params: any) => renderValueAsJSX(params.value,"")
                },
                {
                  headerName: 'Ngày sinh',
                  field: 'contact_birth_day',
                  colId: 'contact_birth_day',
                  width: getWidthFromHeader('Ngày sinh'),
                  cellRenderer: (params: any) => renderValueAsJSX(params.value,"")
                },
                {
                  headerName: 'Giới tính',
                  field: 'contact_gender_name',
                  colId: 'contact_gender_name',
                  width: getWidthFromHeader('Giới tính'),
                  cellRenderer: (params: any) => renderValueAsJSX(params.value,"")
                },
                {
                  headerName: 'Địa chỉ',
                  field: 'contact_address',
                  colId: 'contact_address',
                  width: 200,
                  cellRenderer: (params: any) => renderValueAsJSX(params.value,"")
                },
                {
                  headerName: 'Mối quan hệ',
                  field: 'contact_relationship_type',
                  colId: 'contact_relationship_type',
                  cellRenderer: (params: any) => renderValueAsJSX(params.value,"")
                },
                {
                  headerName: 'Khu vực',
                  field: 'contact_territory_name',
                  colId: 'contact_territory_name',
                  cellRenderer: (params: any) => renderValueAsJSX(params.value,"")
                },
              ]}
              domLayout="autoHeight"
              className="my-auto-height-grid"
              rowHeight={55}
              overlayNoRowsTemplate={`Không có dữ liệu`}
            />
          </div>
        </div>
      </div>
    </Fragment>
  )
}
export default Overview
